import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const LabelsType = ({labels}) => (
    <table className="table table-sm">
        <thead>
            <tr>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.id} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.minLabel} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.maxLabel} /></th>
            </tr>
        </thead>
        <tbody>
            {labels.map((label) => (
                <tr key={label.id}>
                    <td className="value-id">{label.id}</td>
                    <td>{label.minLabel}</td>
                    <td>{label.maxLabel}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default LabelsType;
